import { type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Flex, Group, Text, UnstyledButton } from '@mantine/core';

import { EditIcon, TrashIcon } from 'icons';

type Props = {
  title: string;
  description: string;
  icon: ReactNode;
  isSet: boolean;
  onSetButtonClick: () => void;
  onEditButtonClick: () => void;
  onDeleteButtonClick: () => void;
};

export const SharingSettingsBox = ({
  title,
  description,
  icon,
  isSet,
  onSetButtonClick,
  onEditButtonClick,
  onDeleteButtonClick,
}: Props) => {
  const { t } = useTranslation('forms');

  return (
    <Flex align="center">
      <Box sx={theme => ({ marginRight: theme.other.spacing(1) })}>{icon}</Box>
      <Box sx={{ flex: 1 }}>
        <Text
          size="md"
          fw={600}
          sx={theme => ({ marginBottom: theme.other.spacing(0.5) })}
        >
          {title}
        </Text>
        <Text size="md" color="dimmed">
          {description}
        </Text>
      </Box>
      {isSet ? (
        <Group>
          <UnstyledButton onClick={onEditButtonClick} sx={{ display: 'flex' }}>
            <EditIcon color="blue" />
          </UnstyledButton>
          <UnstyledButton
            onClick={onDeleteButtonClick}
            sx={{ display: 'flex' }}
          >
            <TrashIcon color="red" />
          </UnstyledButton>
        </Group>
      ) : (
        <Button variant="default" onClick={onSetButtonClick}>
          {t('editView.sidebar.sharing.settings.setButton')}
        </Button>
      )}
    </Flex>
  );
};
